// https://www.dbos.dev/videos

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend, FooterLinksFollowOurGithub3 } from '@components/layout/FooterCtas';
import { SlideIn } from '@components/interactions';

export function VideosPage() {
  return (
    <SiteLayout
      banner={true}
      footerCta={
        <>
          <FooterCtaBuildYourReliableBackend />
          <FooterLinksFollowOurGithub3 />
        </>
      }
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            '.clamp-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 3; /* Adjust to the approximate number of lines */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}',
        }}
      />
      <section className="section_videos">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large padding-top">
              <div className="pricing_component">
                <div className="margin-bottom margin-medium">
                  <div className="text-align-center">
                    <div className="max-width-xlarge align-center">
                      <div className="margin-bottom margin-small">
                        <h1 className="heading-style-h1">{'DBOS\u00a0Videos'}</h1>
                      </div>
                      <p className="text-body-active">
                        Explore the DBOS video library to learn more about open source durable execution and workflow
                        orchestration.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_video-list">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-medium">
              <div className="collection-list-wrapper-6 w-dyn-list">
                <div role="list" className="collection-list-11 w-dyn-items">
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/are-your-agents-on-acid" className="w-inline-block">
                      <img
                        src="/assets/cms/6a61abe37c9ee09714f984b2_Are-Your-Agents-On-ACID-DBOS-CockroachLabs.png"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/6a61abe37c9ee09714f984b2_Are-Your-Agents-On-ACID-DBOS-CockroachLabs-p-500.png 500w, /assets/cms/6a61abe37c9ee09714f984b2_Are-Your-Agents-On-ACID-DBOS-CockroachLabs-p-800.png 800w, /assets/cms/6a61abe37c9ee09714f984b2_Are-Your-Agents-On-ACID-DBOS-CockroachLabs-p-1080.png 1080w, /assets/cms/6a61abe37c9ee09714f984b2_Are-Your-Agents-On-ACID-DBOS-CockroachLabs-p-1600.png 1600w, /assets/cms/6a61abe37c9ee09714f984b2_Are-Your-Agents-On-ACID-DBOS-CockroachLabs.png 1920w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">
                            Are Your Agents on ACID - Mike Stonebraker and CockroachLabs
                          </h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">July 16, 2026</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/first-look-at-dbos-for-rust" className="w-inline-block">
                      <img
                        src="/assets/cms/6ab15537b1d55f9aa6d8fbb5_Title-Slide-DBOS-Rust-Walkthrough.png"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/6ab15537b1d55f9aa6d8fbb5_Title-Slide-DBOS-Rust-Walkthrough-p-500.png 500w, /assets/cms/6ab15537b1d55f9aa6d8fbb5_Title-Slide-DBOS-Rust-Walkthrough-p-800.png 800w, /assets/cms/6ab15537b1d55f9aa6d8fbb5_Title-Slide-DBOS-Rust-Walkthrough-p-1080.png 1080w, /assets/cms/6ab15537b1d55f9aa6d8fbb5_Title-Slide-DBOS-Rust-Walkthrough-p-1600.png 1600w, /assets/cms/6ab15537b1d55f9aa6d8fbb5_Title-Slide-DBOS-Rust-Walkthrough.png 1920w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">First Look at DBOS for Rust</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">September 10, 2026</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/user-interview-chris-chan-cto-co-founder-of-riviera" className="w-inline-block">
                      <img
                        src="/assets/cms/6a21ce3e6bb6fdd1a148d711_Title-Slide-Chris-Chan-Riviera-DBOS-Interview.jpg"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/6a21ce3e6bb6fdd1a148d711_Title-Slide-Chris-Chan-Riviera-DBOS-Interview-p-500.jpg 500w, /assets/cms/6a21ce3e6bb6fdd1a148d711_Title-Slide-Chris-Chan-Riviera-DBOS-Interview-p-800.jpg 800w, /assets/cms/6a21ce3e6bb6fdd1a148d711_Title-Slide-Chris-Chan-Riviera-DBOS-Interview-p-1080.jpg 1080w, /assets/cms/6a21ce3e6bb6fdd1a148d711_Title-Slide-Chris-Chan-Riviera-DBOS-Interview-p-1600.jpg 1600w, /assets/cms/6a21ce3e6bb6fdd1a148d711_Title-Slide-Chris-Chan-Riviera-DBOS-Interview.jpg 1920w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">
                            {'User Interview: Chris Chan, CTO & Co-Founder of Riviera'}
                          </h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">June 4, 2026</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/dbos-customer-soria-analytics" className="w-inline-block">
                      <img
                        src="/assets/cms/691e9e7473477d6e0a98cfb5_DBOS-Customer-Interview-Soria-Analytics.webp"
                        loading="lazy"
                        alt=""
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">User Interview: Cameron Spiller, CTO Soria Analytics</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">November 3, 2025</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/dbos-customer-dosu" className="w-inline-block">
                      <img
                        src="/assets/cms/68eec7ffedde60ec918fb128_Dosu-DBOS-Durable-Execution-User-Story-Video.webp"
                        loading="lazy"
                        alt=""
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">User Interview: Devin Stein, Founder of Dosu.dev</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">September 28, 2025</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a
                      href="/webcast/user-interview-yutori-com-agentic-ai-digital-assistants"
                      className="w-inline-block"
                    >
                      <img
                        src="/assets/cms/68eecd7791ee396d76dc5158_Yutori-Yunfan-Ye-DBOS-User-Interview.webp"
                        loading="lazy"
                        alt=""
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">User Interview: Yunfan Ye, Engineering at Yutori.com</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">September 11, 2025</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/dbos-conductor-workflow-visualizations-demo" className="w-inline-block">
                      <img
                        src="/assets/cms/6a30b7a9f07e021e64dd487a_DBOS-UG-June-2026-Workflow-Visualizations-Demo.png"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/6a30b7a9f07e021e64dd487a_DBOS-UG-June-2026-Workflow-Visualizations-Demo-p-500.png 500w, /assets/cms/6a30b7a9f07e021e64dd487a_DBOS-UG-June-2026-Workflow-Visualizations-Demo-p-800.png 800w, /assets/cms/6a30b7a9f07e021e64dd487a_DBOS-UG-June-2026-Workflow-Visualizations-Demo-p-1080.png 1080w, /assets/cms/6a30b7a9f07e021e64dd487a_DBOS-UG-June-2026-Workflow-Visualizations-Demo-p-1600.png 1600w, /assets/cms/6a30b7a9f07e021e64dd487a_DBOS-UG-June-2026-Workflow-Visualizations-Demo.png 1920w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">DBOS Conductor Workflow Visualizations Demo</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">June 11, 2026</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/dbos-openmetrics-demo" className="w-inline-block">
                      <img
                        src="/assets/cms/6a30b5288bd8b5d1ececb36f_DBOS-UG-June-2026-OpenMetrics-Demo.png"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/6a30b5288bd8b5d1ececb36f_DBOS-UG-June-2026-OpenMetrics-Demo-p-500.png 500w, /assets/cms/6a30b5288bd8b5d1ececb36f_DBOS-UG-June-2026-OpenMetrics-Demo-p-800.png 800w, /assets/cms/6a30b5288bd8b5d1ececb36f_DBOS-UG-June-2026-OpenMetrics-Demo-p-1080.png 1080w, /assets/cms/6a30b5288bd8b5d1ececb36f_DBOS-UG-June-2026-OpenMetrics-Demo-p-1600.png 1600w, /assets/cms/6a30b5288bd8b5d1ececb36f_DBOS-UG-June-2026-OpenMetrics-Demo.png 1920w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">DBOS OpenMetrics Demo</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">June 11, 2026</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/durable-queueing-deep-dive" className="w-inline-block">
                      <img
                        src="/assets/cms/69b1ec9faa103bc782931ee9_Feb2026-DBOS-User-Group-Meeting.png"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/69b1ec9faa103bc782931ee9_Feb2026-DBOS-User-Group-Meeting-p-500.png 500w, /assets/cms/69b1ec9faa103bc782931ee9_Feb2026-DBOS-User-Group-Meeting.png 800w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">Durable Queueing Deep Dive</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">February 26, 2026</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/dbos-conductor-walk-through" className="w-inline-block">
                      <img
                        src="/assets/cms/68eed08d063e132b587d4ab7_DBOS-Conductor-Walkthrough-Video.webp"
                        loading="lazy"
                        alt=""
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">DBOS Conductor Walk-through</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">February 19, 2026</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/data-2025-year-in-review-stonebraker-pavlo" className="w-inline-block">
                      <img
                        src="/assets/cms/693f40e63f8443ee6287570b_Mike-Stonebraker-Andy-Pavlo-2025-in-Review3.jpg"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/693f40e63f8443ee6287570b_Mike-Stonebraker-Andy-Pavlo-2025-in-Review3-p-500.jpg 500w, /assets/cms/693f40e63f8443ee6287570b_Mike-Stonebraker-Andy-Pavlo-2025-in-Review3-p-800.jpg 800w, /assets/cms/693f40e63f8443ee6287570b_Mike-Stonebraker-Andy-Pavlo-2025-in-Review3-p-1080.jpg 1080w, /assets/cms/693f40e63f8443ee6287570b_Mike-Stonebraker-Andy-Pavlo-2025-in-Review3.jpg 1200w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">
                            Data 2025 - the Year in Review with Mike Stonebraker and Andy Pavlo
                          </h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">December 10, 2025</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/serverless-past-present-future" className="w-inline-block">
                      <img
                        src="/assets/cms/679c4e264dd18feef86e2c45_Jan-2025-Webcast-Why-Serverless-Past-Present-Future-1200-x-630-px.png"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/679c4e264dd18feef86e2c45_Jan-2025-Webcast-Why-Serverless-Past-Present-Future-1200-x-630-px-p-500.png 500w, /assets/cms/679c4e264dd18feef86e2c45_Jan-2025-Webcast-Why-Serverless-Past-Present-Future-1200-x-630-px-p-800.png 800w, /assets/cms/679c4e264dd18feef86e2c45_Jan-2025-Webcast-Why-Serverless-Past-Present-Future-1200-x-630-px-p-1080.png 1080w, /assets/cms/679c4e264dd18feef86e2c45_Jan-2025-Webcast-Why-Serverless-Past-Present-Future-1200-x-630-px.png 1200w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">Why Didn't Serverless Take Off?</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">January 29, 2025</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/goodbye-lambda-hello-dbos" className="w-inline-block">
                      <img
                        src="/assets/cms/6766460e580ff0daac0618da_Goodbye-Lambda-Hello-DBOS-og.jpg"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/6766460e580ff0daac0618da_Goodbye-Lambda-Hello-DBOS-og-p-500.jpg 500w, /assets/cms/6766460e580ff0daac0618da_Goodbye-Lambda-Hello-DBOS-og-p-800.jpg 800w, /assets/cms/6766460e580ff0daac0618da_Goodbye-Lambda-Hello-DBOS-og-p-1080.jpg 1080w, /assets/cms/6766460e580ff0daac0618da_Goodbye-Lambda-Hello-DBOS-og.jpg 1280w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">{'Goodbye AWS\u00a0Lambda, Hello DBOS'}</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">October 23, 2024</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/durable-ai-orchestration-bauplan-dbos" className="w-inline-block">
                      <img
                        src="/assets/cms/68c39ac2c9e146fd3fda6c7e_Composing-Unbreakable-AI-Workflows-Sept10.png"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/68c39ac2c9e146fd3fda6c7e_Composing-Unbreakable-AI-Workflows-Sept10-p-500.png 500w, /assets/cms/68c39ac2c9e146fd3fda6c7e_Composing-Unbreakable-AI-Workflows-Sept10-p-800.png 800w, /assets/cms/68c39ac2c9e146fd3fda6c7e_Composing-Unbreakable-AI-Workflows-Sept10-p-1080.png 1080w, /assets/cms/68c39ac2c9e146fd3fda6c7e_Composing-Unbreakable-AI-Workflows-Sept10.png 1200w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">Composing Unbreakable AI Workflows with Bauplan and DBOS</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">September 10, 2025</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/introducing-dbos-conductor" className="w-inline-block">
                      <img
                        src="/assets/cms/6805be4fd0576dff0dc4fda1_Durable-Execution-Anywhere-DBOS-Conductor.png"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/6805be4fd0576dff0dc4fda1_Durable-Execution-Anywhere-DBOS-Conductor-p-500.png 500w, /assets/cms/6805be4fd0576dff0dc4fda1_Durable-Execution-Anywhere-DBOS-Conductor-p-800.png 800w, /assets/cms/6805be4fd0576dff0dc4fda1_Durable-Execution-Anywhere-DBOS-Conductor-p-1080.png 1080w, /assets/cms/6805be4fd0576dff0dc4fda1_Durable-Execution-Anywhere-DBOS-Conductor.png 1200w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">Durable Apps Anywhere. Introducing DBOS Conductor</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">April 17, 2025</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/dbos-transact-2-typescript" className="w-inline-block">
                      <img
                        src="/assets/cms/67a6f28c2ce3e47ac5be7dbf_DBOS-Transact-2-TypeScript-Code-Walkthrough-1.png"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/67a6f28c2ce3e47ac5be7dbf_DBOS-Transact-2-TypeScript-Code-Walkthrough-1-p-500.png 500w, /assets/cms/67a6f28c2ce3e47ac5be7dbf_DBOS-Transact-2-TypeScript-Code-Walkthrough-1-p-800.png 800w, /assets/cms/67a6f28c2ce3e47ac5be7dbf_DBOS-Transact-2-TypeScript-Code-Walkthrough-1-p-1080.png 1080w, /assets/cms/67a6f28c2ce3e47ac5be7dbf_DBOS-Transact-2-TypeScript-Code-Walkthrough-1.png 1200w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">DBOS Transact 2.0 for TypeScript Code Walkthrough</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">February 6, 2025</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/what-is-durable-execution" className="w-inline-block">
                      <img
                        src="/assets/cms/6766529e5a3055a584dd4a78_What-Is-Durable-Execution.jpg"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/6766529e5a3055a584dd4a78_What-Is-Durable-Execution-p-500.jpg 500w, /assets/cms/6766529e5a3055a584dd4a78_What-Is-Durable-Execution-p-800.jpg 800w, /assets/cms/6766529e5a3055a584dd4a78_What-Is-Durable-Execution-p-1080.jpg 1080w, /assets/cms/6766529e5a3055a584dd4a78_What-Is-Durable-Execution.jpg 1280w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">What Is Durable Execution</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">December 17, 2024</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/building-cron-jobs" className="w-inline-block">
                      <img
                        src="/assets/cms/676503f8cd2dd6bb840a5477_Getting-Started-With-Cloud-Cron.jpg"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/676503f8cd2dd6bb840a5477_Getting-Started-With-Cloud-Cron-p-500.jpg 500w, /assets/cms/676503f8cd2dd6bb840a5477_Getting-Started-With-Cloud-Cron-p-800.jpg 800w, /assets/cms/676503f8cd2dd6bb840a5477_Getting-Started-With-Cloud-Cron-p-1080.jpg 1080w, /assets/cms/676503f8cd2dd6bb840a5477_Getting-Started-With-Cloud-Cron.jpg 1280w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">Getting Started with Cloud Cron on DBOS</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">December 17, 2024</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/dbos-transact-python" className="w-inline-block">
                      <img
                        src="/assets/cms/676646e7acc82a7e2b95012f_Durable-Execution-Python-og.jpg"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/676646e7acc82a7e2b95012f_Durable-Execution-Python-og-p-500.jpg 500w, /assets/cms/676646e7acc82a7e2b95012f_Durable-Execution-Python-og-p-800.jpg 800w, /assets/cms/676646e7acc82a7e2b95012f_Durable-Execution-Python-og-p-1080.jpg 1080w, /assets/cms/676646e7acc82a7e2b95012f_Durable-Execution-Python-og.jpg 1280w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">How to Build Durable Python Backends that Scale</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">September 12, 2024</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/stored-procedures-good-bad-elegant" className="w-inline-block">
                      <img
                        src="/assets/cms/676649e6edb869e51133f523_DBOS-Stored-Procedures-webcast-og.jpg"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/676649e6edb869e51133f523_DBOS-Stored-Procedures-webcast-og-p-500.jpg 500w, /assets/cms/676649e6edb869e51133f523_DBOS-Stored-Procedures-webcast-og-p-800.jpg 800w, /assets/cms/676649e6edb869e51133f523_DBOS-Stored-Procedures-webcast-og-p-1080.jpg 1080w, /assets/cms/676649e6edb869e51133f523_DBOS-Stored-Procedures-webcast-og.jpg 1280w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">Stored Procedures: The Good, The Bad, and The Elegant</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">August 15, 2024</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/building-event-driven-dbos-apache-kafka" className="w-inline-block">
                      <img
                        src="/assets/cms/67664f27f6ff5b3bc2c78749_Event-Driven-Development-DBOS-Kafka.jpg"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/67664f27f6ff5b3bc2c78749_Event-Driven-Development-DBOS-Kafka-p-500.jpg 500w, /assets/cms/67664f27f6ff5b3bc2c78749_Event-Driven-Development-DBOS-Kafka-p-800.jpg 800w, /assets/cms/67664f27f6ff5b3bc2c78749_Event-Driven-Development-DBOS-Kafka-p-1080.jpg 1080w, /assets/cms/67664f27f6ff5b3bc2c78749_Event-Driven-Development-DBOS-Kafka.jpg 1280w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">Building Event Driven Apps with DBOS and Apache Kafka</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">July 16, 2024</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a
                      href="/webcast/stonebraker-increase-software-engineering-productivity"
                      className="w-inline-block"
                    >
                      <img
                        src="/assets/cms/67664a00cc777b355767c6cb_Mike-Stonebraker-DBOS-OG.jpg"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/67664a00cc777b355767c6cb_Mike-Stonebraker-DBOS-OG-p-500.jpg 500w, /assets/cms/67664a00cc777b355767c6cb_Mike-Stonebraker-DBOS-OG-p-800.jpg 800w, /assets/cms/67664a00cc777b355767c6cb_Mike-Stonebraker-DBOS-OG-p-1080.jpg 1080w, /assets/cms/67664a00cc777b355767c6cb_Mike-Stonebraker-DBOS-OG.jpg 1280w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">
                            How to Gain an Order of Magnitude in Software Productivity
                          </h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">July 11, 2024</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/dbos-interactive-time-travel" className="w-inline-block">
                      <img
                        src="/assets/cms/67664bc9f6ff5b3bc2c65261_Time-Travel-Explained.png"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/67664bc9f6ff5b3bc2c65261_Time-Travel-Explained-p-500.png 500w, /assets/cms/67664bc9f6ff5b3bc2c65261_Time-Travel-Explained-p-800.png 800w, /assets/cms/67664bc9f6ff5b3bc2c65261_Time-Travel-Explained-p-1080.png 1080w, /assets/cms/67664bc9f6ff5b3bc2c65261_Time-Travel-Explained.png 1280w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">DBOS Interactive Time Travel</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">June 19, 2024</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/dbos-cloud-byodb" className="w-inline-block">
                      <img
                        src="/assets/cms/676654ada3b013b57b8168ee_Bring-Your-Own-Database-Explained.png"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/676654ada3b013b57b8168ee_Bring-Your-Own-Database-Explained-p-500.png 500w, /assets/cms/676654ada3b013b57b8168ee_Bring-Your-Own-Database-Explained-p-800.png 800w, /assets/cms/676654ada3b013b57b8168ee_Bring-Your-Own-Database-Explained-p-1080.png 1080w, /assets/cms/676654ada3b013b57b8168ee_Bring-Your-Own-Database-Explained.png 1280w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">Bring Your Own Database to DBOS Cloud</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">June 6, 2024</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    id="w-node-_4a47d8fd-bf73-fc50-0cd3-1f958a209b85-226a3041"
                    role="listitem"
                    className="video-item w-dyn-item"
                  >
                    <a href="/webcast/developing-with-dbos-transact-typescript-framework" className="w-inline-block">
                      <img
                        src="/assets/cms/676649b6d5db8b8ca0dbae79_Webcast-Developing-DBOS-Transact-TypeScript-Framework-OG.jpg"
                        loading="lazy"
                        alt=""
                        sizes="100vw"
                        srcSet="/assets/cms/676649b6d5db8b8ca0dbae79_Webcast-Developing-DBOS-Transact-TypeScript-Framework-OG-p-500.jpg 500w, /assets/cms/676649b6d5db8b8ca0dbae79_Webcast-Developing-DBOS-Transact-TypeScript-Framework-OG-p-800.jpg 800w, /assets/cms/676649b6d5db8b8ca0dbae79_Webcast-Developing-DBOS-Transact-TypeScript-Framework-OG-p-1080.jpg 1080w, /assets/cms/676649b6d5db8b8ca0dbae79_Webcast-Developing-DBOS-Transact-TypeScript-Framework-OG.jpg 1280w"
                        className="video-thumb"
                      />
                      <div className="div-block-69">
                        <div className="margin-bottom margin-xsmall">
                          <h3 className="heading-style-h5">Building Crash-proof Apps on DBOS</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div className="text-body-active text-size-small">April 25, 2024</div>
                        </div>
                        <div className="button-border tertiary-large-10">
                          <div className="button tertiary-large-11">
                            <div className="text-block-4 tertiary-large-12">Watch video</div>
                            <div className="icon-arrow-right tertiary-large-13 w-embed">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                                  fill="var(--_color-scheme-july-2025---background)"
                                />
                                {'\n'}
                              </svg>
                            </div>
                            <div className="icon-chevron-right tertiary-large-14 w-embed">
                              <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
    </SiteLayout>
  );
}
